import script from "./Top.vue?vue&type=script&setup=true&lang=js"
export * from "./Top.vue?vue&type=script&setup=true&lang=js"

import "./Top.vue?vue&type=style&index=0&id=4ad74224&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ad74224"]])

export default __exports__